import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";
import GaugeChart_Bus from "./GaugeChart_Bus";
import PieChartAm from "./PieChartAm";
import "./PdfPage.css";

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const EnergyChart = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [city, setCity] = useState([]);
  const [gauge_data, setgauge_data] = useState({});
  const [legendData, setLegendData] = useState([]);

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/energycity",
        body: { filterdata: gloablfilter },
      },
      gaugeData
    );
    // fetchData({ url: API_URL_MAIN + "pdf_bus/secondpage_total_count_pdf", body: { filterdata: gloablfilter } }, tablecountfunc)
  }, [gloablfilter]);

  const gaugeData = (data) => {
    setCity(data);
  };

  const cityChunks = chunkArray(city, 4);
  //   const cityChunks = [
  //     ["Bangalore", "Delhi", "Jammu", "Srinagar"],
  //     ["Bangalore1", "Delhi1", "Jammu1", "Srinagar1"],
  //     ["Bangalore2", "Delhi2", "Jammu2", "Srinagar2"],
  //   ];

  //   useEffect(() => {
  //     if (cityChunks.length > 0) {
  //       console.log("cityChunks", cityChunks);
  //     }
  //   }, [cityChunks]);

  const handleLegendData = (data) => {
    setLegendData(data);
  };
  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      cityChunks,
    }),
  }));
  return (
    <div className="energypage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div className="row mt-2">
        <div className="col-md-8">
          <span
            className="text-left"
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              color: "#002060",
              paddingLeft: "30px",
            }}
          >
            Consumption Fraction Breakdown{" "}
          </span>
          <span
            className="text-right"
            style={{ color: "#002060", fontSize: "12px" }}
          >
            {props.startdate} - {props.enddate}
          </span>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-9">
          <div className="row">
            <div className="col-md-2">
              <div
                className="square text-left"
                style={{
                  height: "25px",
                  width: "25px",
                  borderRadius: "3px",
                  backgroundColor: "#3e689f",
                }}
              ></div>
              <div className="text"> Trac. Sys</div>
            </div>
          </div>
        </div>
        <div className="col-md-1"></div>
      </div> */}
      <div className="cont" id="energy-legends">
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#3e689f" }}></div>
          <div class="number">Trac. Sys.</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#ff6600" }}></div>
          <div class="number">HVAC</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#808080" }}></div>
          <div class="number">AUX-1</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#91aed4" }}></div>
          <div class="number">AUX-2</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#FCCF55" }}></div>
          <div class="number">DC-DC</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#30895E" }}></div>
          <div class="number">BCS-1</div>
        </div>
        <div class="box-wrapper">
          <div class="box" style={{ backgroundColor: "#02055A" }}></div>
          <div class="number">BCS-2</div>
        </div>
      </div>

      <div className="row">
        {cityChunks?.length > 0 &&
          cityChunks?.map((chunk, index) => (
            <>
              <div className="col-md-1"></div>
              <div
                className="col-md-11 mb-4"
                key={index}
                style={{
                  border: "2px solid #6f6868",
                  borderRadius: "8px",
                  margin: "0px 20px 0px 55px",
                }}
                id={`${index + 1}-energyChart`}
              >
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {chunk?.map((cityData, index) => (
                    <div
                      className="col-md-3"
                      key={index}
                      style={{
                        top: "10px",
                        paddingBottom: "32px",
                      }}
                    >
                      <PieChartAm
                        key={index}
                        gloablfilter={gloablfilter}
                        city={cityData}
                        setLegendData={handleLegendData}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-1"></div>
            </>
          ))}
      </div>

      <div className="row bottomcontent pl-4" style={{ paddingTop: "10px" }}>
        <div className="col-md-3">
          <img
            src="../../../assets/img_Bus/Pdf_Page/footer.png"
            alt=""
            style={{ height: "70px", width: "200px" }}
          />
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-4">
          <p
            style={{
              fontSize: "11px",
              paddingTop: "60px",
              paddingLeft: "10px",
            }}
          >
            Copyright, Confidential, Tata Motors Limited
          </p>
        </div>
      </div>
    </div>
  );
});
export default EnergyChart;
